import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { cleanMaskedNumber } from '@/utilities'
import { handleError } from '@/store/handle-error'

export const PEMarriagesCardActions = {
  initPeMarriagesCard: ({ commit }, index) => {
    commit('setPeMarriagesCardLock', { index, lock: true })
  },
  peMarriagesCardCreate: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      post('/party_characteristics', {
        spouses: {
          party_id: party.id,
          a_number: cleanMaskedNumber(section.a_number),
          birth_country_id: section.birth_country_id,
          deceased: section.deceased,
          dependent_of_id: section.dependent_of_id,
          dob: section.dob,
          first_name: section.first_name,
          gender_id: section.gender_id,
          immigration_status: section.immigration_status,
          immigration_status_other: section.immigration_status_other,
          income_verification: section.income_verification,
          last_name: section.last_name,
          linked_party_id: section.linked_party_id,
          marriage_date: section.marriage_date,
          marriage_date_uncertain: section.marriage_date_uncertain,
          marriage_place: section.marriage_place,
          marriage_type: section.marriage_type,
          middle_name: section.middle_name,
          monthly_income: section.monthly_income,
          no_a_number: section.no_a_number,
          notes: section.notes,
          city_of_birth: section.city_of_birth,
          state_of_birth: section.state_of_birth,
          residence_country_id: section.residence_country_id,
          resides_with_id: section.resides_with_id,
          termination_date: section.termination_date,
          termination_date_uncertain: section.termination_date_uncertain,
          termination_place: section.termination_place,
          termination_type: section.termination_type,
          uncertain_dob: section.uncertain_dob,
        },
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeMarriagesCardLock', { index, lock: true })
        commit('pePatchParty', {
          spouses: updatedParty.spouses || [],
        })
      }).
      catch(handleError)
  },
  peMarriagesCardRefresh: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/party_characteristics/spouses/${section.id}`).
      then(({ data }) => {
        commit('setPeMarriagesCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'spouses',
          value: data,
        })
      }).
      catch(handleError)
  },
  peMarriagesCardUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/party_characteristics/${id}`, {
        spouses: {
          party_id: party.id,
          a_number: cleanMaskedNumber(section.a_number),
          birth_country_id: section.birth_country_id,
          deceased: section.deceased,
          dependent_of_id: section.dependent_of_id,
          dob: section.dob,
          first_name: section.first_name,
          gender_id: section.gender_id,
          immigration_status: section.immigration_status,
          immigration_status_other: section.immigration_status_other,
          income_verification: section.income_verification,
          last_name: section.last_name,
          linked_party_id: section.linked_party_id,
          marriage_date: section.marriage_date,
          marriage_date_uncertain: section.marriage_date_uncertain,
          marriage_place: section.marriage_place,
          marriage_type: section.marriage_type,
          middle_name: section.middle_name,
          monthly_income: section.monthly_income,
          no_a_number: section.no_a_number,
          notes: section.notes,
          city_of_birth: section.city_of_birth,
          state_of_birth: section.state_of_birth,
          residence_country_id: section.residence_country_id,
          resides_with_id: section.resides_with_id,
          termination_date: section.termination_date,
          termination_date_uncertain: section.termination_date_uncertain,
          termination_place: section.termination_place,
          termination_type: section.termination_type,
          uncertain_dob: section.uncertain_dob,
        },
        id,
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeMarriagesCardLock', { index, lock: true })
        commit('pePatchParty', {
          spouses: updatedParty.spouses || [],
        })
      }).
      catch(handleError)
  },
  peMarriagesCardDelete: async ({ commit, getters }, { id, index }) => {
    const party = getters.peParty

    return axiosRequest.
      delete(`/party_characteristics/${id}`, {
        data: {
          spouses: {
            party_id: party.id,
          },
          id,
        },
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeMarriagesCardLock', { index, lock: true })
        commit('pePatchParty', {
          spouses: updatedParty.spouses || [],
        })
      }).
      catch(handleError)
  },
  peMarriagesCardAddSection: ({ commit }) => {
    commit('setPeMarriagesCardLock', { index: 'new', lock: false })
    commit('addPeMarriagesCardSection', {
      id: null,
      a_number: null,
      birth_country_id: null,
      deceased: null,
      dependent_of_id: null,
      dob: null,
      first_name: null,
      gender_id: null,
      immigration_status: null,
      immigration_status_other: null,
      income_verification: null,
      last_name: null,
      linked_party_id: null,
      marriage_date: null,
      marriage_date_uncertain: false,
      marriage_place: null,
      marriage_type: null,
      middle_name: null,
      monthly_income: null,
      no_a_number: null,
      notes: null,
      city_of_birth: null,
      state_of_birth: null,
      residence_country_id: null,
      resides_with_id: null,
      termination_date: null,
      termination_date_uncertain: false,
      termination_place: null,
      termination_type: null,
      uncertain_dob: false,
    })
  },
}

export const PEMarriagesCardMutations = {
  setPeMarriagesCardLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.MarriagesCard) Vue.set(state.partyEdit.partySections, 'MarriagesCard', {})
    Vue.set(state.partyEdit.partySections.MarriagesCard, index, lock)
  },
  addPeMarriagesCardSection: (state, section) => {
    state.partyEdit.party.spouses.push(section)
  },
  peMarriagesCardCreateUndo: state => state.partyEdit.party.spouses.pop(),
}

export const PEMarriagesCardGetters = {
  peMarriagesCardLock: state => index => state.partyEdit.partySections.MarriagesCard[index],
  peMarriagesCardHasNewSection: (_, getters) => !!getters.peParty.spouses?.find(spouse => spouse.id === null),
}
